import { useState } from 'react';
import { useCustom } from '@refinedev/core';
import { Card, Segmented } from 'antd';
import { Area } from '@ant-design/charts';
import { BOTTOM_LEGEND } from '@/pages/dashboard/chartLegend';
import type { DailyReadersOut } from '@/api/generated/schemas';

const PERIODS = [
  { label: '7 dni', value: 7 },
  { label: '30 dni', value: 30 },
  { label: '90 dni', value: 90 },
];

export const DailyReadersChart = () => {
  const [days, setDays] = useState(30);

  const { query } = useCustom<DailyReadersOut[]>({
    url: 'progress/sessions/stats/readers',
    method: 'get',
    config: { query: { days } },
  });

  const data = (query.data?.data ?? []) as DailyReadersOut[];

  return (
    <Card
      title="Dzienny trend czytelników"
      extra={
        <Segmented
          options={PERIODS.map((p) => ({ label: p.label, value: p.value }))}
          value={days}
          onChange={(v) => setDays(v as number)}
        />
      }
      loading={query.isLoading}
    >
      <Area
        data={data}
        xField="date"
        yField="unique_readers"
        height={240}
        legend={BOTTOM_LEGEND}
      />
    </Card>
  );
};
